import { connect } from 'react-redux';
import ExportButton from './ExportButton';
import { getExportLinkActionCreator } from '../data/actions';

const mapStateToProps = state => ({});

const mapDispatchToProps = { getExportLinkActionCreator };

export default connect(mapStateToProps, mapDispatchToProps)(ExportButton);
